export default "__VITE_ASSET__Ba$Qz1uv__"